import React, { useEffect, useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import { Document, Page, pdfjs } from "react-pdf";

// PDF worker
pdfjs.GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

export default function CataloguePopup() {
  const [open, setOpen] = useState(false);
  const [pdfList, setPdfList] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [numPages, setNumPages] = useState(null);

  const [apiLoading, setApiLoading] = useState(true);
  const [pdfLoading, setPdfLoading] = useState(true);
  
  const [error, setError] = useState(null);
  const bookletRef = useRef(null);
const isMobile = window.innerWidth < 480;

const DEFAULT_WIDTH = isMobile ? 280 : 360;
const DEFAULT_HEIGHT = isMobile ? 380 : 480;

const [bookWidth, setBookWidth] = useState(DEFAULT_WIDTH);


  useEffect(() => {
  fetchPDFs();
}, []);


  const fetchPDFs = async () => {
  try {
    const response = await fetch(
      "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_pdf"
    );
    const data = await response.json();

    if (data?.status && data?.data?.length > 0) {
      setPdfList(data.data);

      const pdfUrl = `https://cyberathon.com/NLF/${data.data[0].pdf}`;
      setSelectedPdf(pdfUrl);

      // 🔥 preload PDF
      fetch(pdfUrl);

      // ✅ OPEN POPUP ONLY IF PDF EXISTS
      setTimeout(() => {
        setOpen(true);
      }, 3000);

    } else {
      // ❌ DO NOTHING — no popup
      setOpen(false);
    }
  } catch (err) {
    // ❌ DO NOTHING — no popup
    setOpen(false);
  } finally {
    setApiLoading(false);
  }
};


  useEffect(() => {
  if (!bookletRef.current) return;

  const resizeObserver = new ResizeObserver(([entry]) => {
    setBookWidth(entry.contentRect.width);
  });

  resizeObserver.observe(bookletRef.current);

  return () => resizeObserver.disconnect();
}, []);


  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPdfLoading(false);
  };

  const handlePdfSelect = (pdfPath) => {
    setPdfLoading(true);
    setNumPages(null);
    setSelectedPdf(`https://cyberathon.com/NLF/${pdfPath}`);
  };

  const handleDownload = () => {
    if (!selectedPdf) return;
    const link = document.createElement("a");
    link.href = selectedPdf;
    link.download = "Catalogue.pdf";
    link.target = "_blank";
    link.click();
  };

  if (!open) return null;

const bookHeight = Math.round(bookWidth * 1.414); // A4 ratio

  return (
    <div className="popup-overlay">
      <button
          className="close-popup-btn"
          onClick={() => setOpen(false)}
        >
          ✖
        </button>
      <div className="popup-box">

        {/* API LOADING */}
        {apiLoading ? (
          <div className="loader">Loading catalogues…</div>
        ) : error ? (
          <div className="pdf-error">{error}</div>
        ) : (
          <>
            {/* PDF SELECTOR */}
            {pdfList.length > 1 && (
              <div className="pdf-selector">
                <label>Select Catalogue</label>
                <select onChange={(e) => handlePdfSelect(e.target.value)}>
                  {pdfList.map((pdf, i) => (
                    <option key={i} value={pdf.pdf}>
                      Catalogue {i + 1}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* PDF VIEWER */}
            <div className="booklet-wrapper" ref={bookletRef}>
              <Document
                file={selectedPdf}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={<div className="loader">Loading PDF…</div>}
                error={<div className="pdf-error">Failed to load PDF</div>}
              >
                {bookWidth > 0 && (
                  <HTMLFlipBook
                    width={bookWidth}
                    height={bookHeight}
                    showCover
                    mobileScrollSupport
                  >
                    {Array.from({ length: numPages }).map((_, i) => (
                      <div key={i} className="page">
                        <Page
                            pageNumber={i + 1}
                            width={bookWidth}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                          />
                      </div>
                    ))}
                  </HTMLFlipBook>
                )}
              </Document>

              {pdfLoading && (
                <div className="loader">Preparing pages…</div>
              )}
            </div>
            <div className="text-end">
            <p className="text-danger" style={{fontSize:"10px", marginBottom:"0"}}>*Click here to flip page</p>
            </div>

            {/* DOWNLOAD */}
            <button
              className="download-btn"
              onClick={handleDownload}
              disabled={!selectedPdf}
            >
              Download Catalogue
            </button>
          </>
        )}
      </div>
    </div>
  );
}
